import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { DISH_FIELDS_CONFIG } from '../../constants'
import { selectDishById } from '../../redux/selectors'
import { transformMainOrChoiceIngredientForDisplay } from '../../transformers'

import DishIngredientsDrawerTable from './dish-ingredients-drawer-table'

const DishIngredientsDrawerContent = ({ dishId, drawerType, isDisabled }) => {
  const dish = useSelector(state => selectDishById(state, dishId))

  const fieldName = DISH_FIELDS_CONFIG[drawerType].value

  const drawerIngredients = useMemo(
    () =>
      map(dish?.[fieldName], ingredient =>
        transformMainOrChoiceIngredientForDisplay(ingredient),
      ),

    [dish, fieldName],
  )

  const tableData = useMemo(
    () => [
      ...map(drawerIngredients, ingredient => ({
        id: ingredient.ingredient?.id,
        menuText: ingredient.word,
        highlight: ingredient.highlight,
        name: ingredient.ingredient?.name,
        isSuggestedUsingMl: ingredient.isSuggestedUsingMl,
        isSuggestedUsingParser: ingredient.isSuggestedUsingParser,
        isDiscrepancyAccepted: ingredient.isDiscrepancyAccepted,
        mlScore: ingredient.mlScore,
      })),
    ],
    [drawerIngredients],
  )

  if (isEmpty(drawerIngredients)) {
    return null
  }

  return (
    <DishIngredientsDrawerTable
      data={tableData}
      fieldName={fieldName}
      dishId={dishId}
      isDisabled={isDisabled}
    />
  )
}

DishIngredientsDrawerContent.propTypes = {
  dishId: PropTypes.number.isRequired,
  drawerType: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
}

DishIngredientsDrawerContent.defaultProps = {
  isDisabled: false,
}

export default DishIngredientsDrawerContent
